<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.primaryPattern"]);

const color = ref();
const oppositeColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.primaryPattern"].value;
  oppositeColor.value = __color.set(color.value).opposite(true).toString();
});
</script>

<template>
  <!-- 不设置 width="64" height="64" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 48C33.1111 48 34 47.1015 34 46.0045L34 26.0006C34 24.8921 33.0994 24.0052 32 24.0052C30.9006 24.0052 30 24.9037 30 26.0006L30 45.9929C30 47.1015 30.8889 48 32 48ZM32 19.9909C33.1111 19.9909 34 19.0924 34 17.9955C34 16.8869 33.0994 16 32 16C30.9006 16 30 16.8985 30 17.9955C30 19.0924 30.8889 19.9909 32 19.9909Z"
      :fill="oppositeColor"
    />
  </svg>
</template>
